import {
  IStat,
  IStatsList,
  StatsResolution,
} from 'components/src/stats/constants';
import { createAction } from 'redux-actions';
import {
  STATS_SET_ALL_TIME,
  STATS_SET_DATA_DAYS,
  STATS_SET_DATA_WEEKS,
  STATS_SET_LOAD_ERROR,
  STATS_SET_LOAD_IS_BUSY,
  STATS_SET_TODAY,
  STATS_SET_TOTAL_DURATION,
} from './constants/ActionTypes';
import { IDurationTotal, IStatsLoadError } from './model';

const setStatToday = createAction<IStat, IStat>(
  STATS_SET_TODAY,
  (data: IStat) => data
);

const setStatsDuration = createAction<IDurationTotal, IDurationTotal>(
  STATS_SET_TOTAL_DURATION,
  (data: IDurationTotal) => data
);

const setStatAllTime = createAction<IStat, IStat>(
  STATS_SET_ALL_TIME,
  (data: IStat) => data
);

const setStatsLoadIsBusy = createAction<StatsResolution, StatsResolution>(
  STATS_SET_LOAD_IS_BUSY,
  (data: StatsResolution) => data
);

const setStatsLoadError = createAction<IStatsLoadError, IStatsLoadError>(
  STATS_SET_LOAD_ERROR,
  (data: IStatsLoadError) => data
);

const setStatsDataDays = createAction<IStatsList, IStatsList>(
  STATS_SET_DATA_DAYS,
  (data: IStatsList) => data
);

const setStatsDataWeeks = createAction<IStatsList, IStatsList>(
  STATS_SET_DATA_WEEKS,
  (data: IStatsList) => data
);

export {
  setStatToday,
  setStatsDuration,
  setStatAllTime,
  setStatsLoadIsBusy,
  setStatsLoadError,
  setStatsDataDays,
  setStatsDataWeeks,
};



// WEBPACK FOOTER //
// ./src/reading-stats/actions.ts